import React from 'react'

const ArchivedProject = ({ name, date, surface, address, i }) => (
  <div className='item' data-sal='slide-down' data-sal-delay={(i + 1) * 100 } data-sal-duration='500' data-sal-easing='ease-out'>
    <p><span>{name}</span> - {date} - {surface} - {address}</p>
  </div>
)

export default ArchivedProject
